import type { ContactItem } from '@api';

export const getContactString = (
  contact?: Partial<ContactItem> | null,
  showEmail = false
) => {
  if (!contact) return '';
  if (showEmail && contact.email) return contact.email;

  const { first_name, last_name } = contact;
  return [first_name || '', last_name || ''].filter(Boolean).join(' ');
};
